import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import api from "../lib/api";
import { useStore } from "../context/StoreContext";
import ProductCard from "../components/ProductCard";

export default function Wishlist() {
  const { wishlist } = useStore();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const results = await Promise.all(wishlist.map((id) => api.get(`/products/${id}`).then((r) => r.data).catch(() => null)));
        setProducts(results.filter(Boolean));
      } catch {} finally { setLoading(false); }
    })();
  }, [wishlist]);

  return (
    <div className="luxy-container py-12 sm:py-16">
      <p className="eyebrow mb-3">Saved Pieces</p>
      <h1 className="font-serif text-4xl sm:text-5xl text-pitch tracking-tight mb-10">Wishlist</h1>
      {!loading && products.length === 0 ? (
        <div className="py-20 text-center" data-testid="wishlist-empty-state">
          <Heart className="w-12 h-12 mx-auto text-stonemuted mb-5" strokeWidth={1} />
          <p className="font-serif text-2xl text-pitch">Your wishlist is empty</p>
          <p className="text-stonemuted mt-2">Save pieces you love to revisit them later.</p>
          <Link to="/shop" className="inline-block mt-6 text-xs font-mono uppercase tracking-[0.2em] border-b border-pitch pb-1">Explore the Archive</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
